import classNames from 'classnames';
import React from 'react';

import { childrenGetter } from '../utils/childrenGetter';

import styles from './styles.module.scss';

interface ContentProps<T> extends Omit<React.AllHTMLAttributes<HTMLDivElement>, 'as'> {
  as?: string | React.ComponentType<T>;
}

function Content<T extends { className?: string }>({ className, as: Component = 'div', ...props }: ContentProps<T>) {
  //@ts-ignore
  return <Component className={classNames(styles.mainListWrapper, className)} {...props} />;
}

function Heading<T extends { className?: string }>({
  as: Component = 'div',
  className,
  children,
  ...props
}: React.PropsWithChildren<{ as?: string | React.ComponentType<T> } & Omit<T, 'as'>>) {
  return (
    //@ts-ignore
    <Component className={classNames(styles.heading, className)} {...props}>
      {children}
    </Component>
  );
}

const Foot: React.FC = ({ children }) => {
  return <>{children}</>;
};

export const ListContentLayout: React.FC<React.AllHTMLAttributes<HTMLDivElement>> & {
  Content: typeof Content;
  Heading: typeof Heading;
  Foot: typeof Foot;
} = ({ children }) => {
  const [content, heading, foot] = childrenGetter(children, [Content, Heading, Foot]);
  return (
    <div className={styles.wrapper}>
      {heading}
      {content}
      {foot}
    </div>
  );
};

ListContentLayout.Content = Content;
ListContentLayout.Heading = Heading;
ListContentLayout.Foot = Foot;
